import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { ContentBlock } from 'components/ContentBlock'
import { TextArea } from 'components/forms'
import { useTranslation } from 'react-i18next'

const WaiterKey = ({ data, mutations: { updateItem } }) => {
	const [t] = useTranslation()
	const updateWaiterKey = e => {
		const waiterKey = e.target.value
		updateItem({ waiterKey })
	}
	return(
		<ContentBlock>
			<Row>
				<Col xs={4}>
					<p className='form-group-label'>{t('user_section.sub_sections.waiter_key')}</p>
					<TextArea noForm onBlur={updateWaiterKey} /*info={<InfoComponent/>}*/defaultValue={data.waiterKey} />
					<div style={{ fontSize: '12px', fontWeight: '300', width: '300px' }}>
						{t('user_section.strings.waiter_key_desc')}
					</div>
				</Col>
			</Row>
		</ContentBlock>
	)
}

// const InfoComponent = () => (
// 	<div>
// 		<p>EAN mit Betrag erfassen Sie so:</p>
// 		{`12345678PPPPP ( 7 Zeichen fur PLU, 6 Zeichen <P>  fur Preis und Prufziffer).`}
// 		<p>Beispiel:</p>
// 		{`12345678 -> 1234567 ist die PLU, 1.25 ist der Preis, 4 ist die Prufziffer`}
// 	</div>
// )

export default WaiterKey
